<template>
  <div class="flex-row">
    <!-- <el-col :span="3" class="flex-col"> -->
    <div class="side-box">
      <div class="project-side">{{ Lang.btn.reportClassification }}</div>
      <div class="tree-box report-tree">
        <el-scrollbar>
          <sideTree 
            ref="sideTree"
            @addTable="handleAddTable"
            @nodeClick="handleTreeNodeClick"
            @editTable="handleEditTable"
            @editType="handleEditType"
            @deleteType="handleDeleteType"
            @deleteTable="handleDeleteTable"
            @getData="searchFirstItem"
            >
          </sideTree>
        </el-scrollbar>
      </div>
      <div class="add-box">
        <comp-button size="medium" icon="icon-add" style="width: 100%;background: linear-gradient(180deg, #f4f5f7 0%,#ffffff 100%);" @click="addType">{{ Lang.btn.addClassify }}</comp-button>
        <!-- <el-button icon="el-icon-plus" type="default" @click="addType"></el-button> -->
      </div>
    </div>
    <!-- </el-col> -->
    <div class="hide_avue_crud_header">
      <breadcrumb :repeat="true" v-if="website.setting.breadcrumb" />
      <basic-container  style="min-width: 857px;width: calc(100vw - 343px)">
        <searchBar ref="searchBar" :showTimeType="true" :showCompareType="true" :showSearchButton="true" @change="handleSearchChange" />
        <!-- 折线图 -->
        <el-row class="line-chart-box">
          <LineChart :title="Lang.graph.energyCostTrend" chartType="lineArea" key="dataStatistics-lineChart" ref="LightChart" @refresh="refreshChange" style="height: 250px;"></LineChart>
        </el-row>
        <avue-crud
          :option="option"
          v-model:search="search"
          :table-loading="loading"
          :data="tableData"
          ref="crud"
          v-model="form"
          :permission="permissionObj"
          :before-open="beforeOpen"
          v-model:page="page"
          @search-change="searchChange"
          @search-reset="searchReset"
          @selection-change="selectionChange"
          @current-change="currentChange"
          @size-change="sizeChange"
          @refresh-change="refreshChange"
          @on-load="onLoad"
        >
        </avue-crud>
        <el-drawer :title="Lang.btn.addClassify" append-to-body v-model="typeDialog" size="50%" >
          <avue-form v-if="typeDialog" :option="formOption" v-model="typeForm" @submit="handleSubmit">
          </avue-form>
        </el-drawer>

        <el-drawer :title="Lang.btn.addReport" append-to-body v-model="addTableDialog" size="90%" >
          <addTable v-if="addTableDialog" ref="addTable" :operationType="operationType" :reportId="reportId" :groupId="groupId" @success="handleSuccess"></addTable>
        </el-drawer>
      </basic-container>
    </div>
  </div>
</template>

<script>
import {
  getUser,
} from '@/api/system/user';
import { getDeptTree } from '@/api/system/dept';
import { update, save, remove } from '@/api/energyManage/tree';
import { getReportDataPage, removeReport } from '@/api/energyManage/reportData'
import { exportBlob } from '@/api/common';
import { mapGetters } from 'vuex';
import website from '@/config/website';
import { getToken } from '@/utils/auth';
import { downloadXls, findInTreeIterative } from '@/utils/util';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import func from '@/utils/func';
import LineChart from './comps/lineChart.vue';
import sideTree from './comps/sideTree.vue';
import addTable from './dataStastisticsAddTable.vue';
import searchBar from './comps/searchBarReport.vue';
import { deepClone } from '@/utils/util';

export default {
  components: {
    LineChart,
    sideTree,
    addTable,
    searchBar,
  },
  data() {
    return {
      form: {},
      deptTreeData: {},
      treeForm: {},
      typeForm: {},
      search: {},
      typeDialog: false,
      showAvueCard: true,
      excelBox: false,
      addTableDialog: false,
      initFlag: true,
      auditMode: false,
      selectionList: [],
      query: {},
      data: [], // 接口获取原始数据图表使用
      tableData: [], // 组装好的表格使用数据
      loading: true,
      platformLoading: false,
      groupId: '', // 分类ID
      reportId: '', // 报表ID
      operationType: 'add',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      platformPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        roleTree: [],
        deptTree: [],
      },
      props: {
        label: 'title',
        value: 'key',
      },
      roleGrantList: [],
      roleTreeObj: [],
      treeDeptId: '',
      treeData: [],
      formOption: {
        labelWidth: 130,
        gutter: 20,
        column: [
          {
            label: this.Lang.label.category,
            rules: [
              {
                required: true,
                trigger: 'click',
                message: this.Lang.tips.inputCategory
              },
            ],
            prop: 'name'
          },
          {
            label: this.Lang.label.orgOf,
            props: {
              label: 'title',
              value: 'codes',
            },
            treeLoad: function (node, resolve) {
              const param = this.getDeptParam();
              getDeptTree(param).then(res => {
                resolve(
                  res.data.data.map(item => {
                    return {
                      ...item,
                      leaf: !item.hasChildren,
                    };
                  })
                );
              });
            },
            type: 'tree',
            lazy: false,
            dataType: 'string',
            slot: true,
            prop: 'deptId',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectOrg,
                trigger: 'blur',
              },
            ],
            span: 12,
          },
        ]
      },
      option: {
        height: 'auto',
        stripe: false,
        calcHeight: 96, // 表格的高度增加量，默认为自动高度。如果设置为auto，会自适应窗口高度。
        tip: false,
        searchShow: true, // 搜索栏
        searchMenuSpan: 6,
        labelWidth: 180,
        headerAlign: 'center',
        align: 'center',
        border: true, // 每行的竖线
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: false, // 选择
        menuWidth: 310, // 操作列宽
        addBtn: false, // 添加
        menu: false,
        viewBtn: true, // 查看
        editBtn: true, // 编辑
        delBtn: true, // 删除
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        dialogType: 'drawer',
        dialogClickModal: false,
        column: [ // 表格列
          {
            label: this.Lang.table.time,
            prop: 'xval',
            search: false,
            display: false, // 弹出表单是否显示
          },
        ],
      },
      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: this.Lang.tips.templateUpload,
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: this.Lang.tips.templateUploadingPlzWait,
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: this.Lang.tips.plzUploadStandarFile,
            action: '/blade-system/user/import-user',
          },
          {
            label: this.Lang.tips.dataCover,
            prop: 'isCovered',
            type: 'switch',
            align: 'center',
            width: 80,
            dicData: [
              {
                label: this.Lang.label.no,
                value: 0,
              },
              {
                label: this.Lang.label.yes,
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectIfCover,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.tips.templateDownload,
            prop: 'excelTemplate',
            formslot: true,
            span: 24,
          },
        ],
      },
    };
  },
  watch: {
    'form.tenantId'() {
      if (this.form.tenantId !== '' && this.initFlag) {
        this.initData(this.form.tenantId);
      }
    },
    'excelForm.isCovered'() {
      if (this.excelForm.isCovered !== '') {
        const column = this.findObject(this.excelOption.column, 'excelFile');
        column.action = `/blade-system/user/import-user?isCovered=${this.excelForm.isCovered}`;
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo', 'menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // 非租户模式默认加载管理组数据
    // if (!website.tenantMode) {
    //   this.initData(website.tenantId);
    // }
    this.initData(website.tenantId);
    // func.calculateHeaderHeight(this);
  },
  methods: {
    getDeptParam() {
      const userStr = localStorage.getItem('saber-userInfo') || '{}';
      const userInfo = JSON.parse(userStr)
      const params = {
        tenantId: userInfo.content?.tenant_id,
        deptId: userInfo.content?.dept_id,
      }
      return params;
    },
    searchFirstItem(list) {
      if (list.length) {
        const firstItem = list[0] || {}
        if (firstItem.childTreeList) {
          const item = firstItem.childTreeList[0] || {};
          if (item.id) {
            this.handleTreeNodeClick(item);
          }
        }
      }
    },
    // 添加分类
    addType(row, index) {
      this.operationType = 'add';
      this.reportId = '';
      this.typeForm = {};
      this.typeDialog = true;
    },
    handleTreeNodeClick(data) {
      this.reportId = data.id;
      const param = this.$refs.searchBar.getParams();
      this.getPageList(Object.assign(this.query, param));
    },
    // 编辑分类
    handleEditType(node) {
      this.operationType = 'edit';
      this.reportId = '';
      this.typeForm = node.data;
      this.typeDialog = true;
    },
    handleSearchChange(params) {
      this.query = Object.assign(this.query, params);
      this.page.currentPage = 1;
      this.getPageList(this.query);
    },
    // 新增报表点的是分类
    handleAddTable(node) {
      this.groupId = node.data.id; // 分类ID 查询和保存时用
      this.reportId = '';
      this.operationType = 'add';
      this.addTableDialog = true;
    },
    // 编辑报表
    handleEditTable(node) {
      this.groupId = node.parent.data.id;
      this.reportId = node.data.id; // 报表ID 查询和保存时用
      this.operationType = 'edit';
      this.addTableDialog = true;
    },
    // 添加报表成功
    handleSuccess() {
      this.addTableDialog = false;
      this.$refs.sideTree.getTreeData();
      this.searchReset();
    },
    handleSubmit(data, done, loading) {
      const params = {
        parentId: data.id,
        ...data
      }
      const submitFunction = this.operationType === 'edit' ? update : save;
      const userInfo = this.getDeptParam();
      const ownerItem = findInTreeIterative(this.deptTreeData, (node) => node.id === userInfo.deptId);
      if (params.deptId != ownerItem.codes) {
        done()
        return this.$message.error(this.Lang.tips.cantSelectSuperiorDept);
      }
      submitFunction(params).then(
        () => {
          this.initFlag = false;
          this.$emit('refresh');
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.typeDialog = false;
          this.$refs.sideTree.getTreeData();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    initData(tenantId) {
      const params = this.getDeptParam()
      getDeptTree(params).then(res => {
        const column = this.findObject(this.formOption.column, 'deptId');
        const data = res.data.data;
        column.dicData = data;
        this.deptTreeData = data;
      });
    },
    searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = deepClone(list);
    },
    // selectionClear() {
    //   this.selectionList = [];
    //   this.$refs.crud && this.$refs.crud.toggleSelection();
    // },
    // 删除分类
    handleDeleteType(node) {
      const id = node.data.id;
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.sideTree.getTreeData();
        });
    },
    // 删除报表
    handleDeleteTable(node) {
      const id = node.data.id;
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return removeReport(id);
        })
        .then(() => {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.sideTree.getTreeData();
          this.refreshChange()
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getUser(this.form.id).then(res => {
          this.form = res.data.data;
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = func.split(this.form.roleId);
          }
          if (this.form.hasOwnProperty('postId')) {
            this.form.postId = func.split(this.form.postId);
          }
        });
      }
      this.initFlag = true;
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(params = {}) {
      this.getPageList(this.query)
    },
    getPageListB() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      const param = {
        compareType: 0, // 默认值
        dataType: 1, // 默认值
        ...this.query,
      }
      getReportDataPage(param).then(res => {
        const data = res.data?.data || [];
        const tableData = [];
        const chartData = []; // 同环比拆成两条线
        const columns = [{
          label: this.Lang.table.time,
          prop: 'xval',
          search: false,
          display: false, // 弹出表单是否显示
        }];
        data.forEach(item => {
          const xvals = item.xvals;
          const yvals = item.yvals || [];
          const yearOnYearVals = item.yearOnYearVal || []; // 同比数据
          const linkRelativeVals = item.linkRelativeVal || []; // 环比数据
          if (xvals.length) {
            xvals.forEach((val, i) => {
              if (param.compareType == '3') {
                tableData.push({
                  xval: val,
                  yearOnYearVal: yearOnYearVals[i],
                  itemIdName: item.itemIdName,
                  rtuName: item.rtuName,
                  itemId: item.itemId,
                  rtuId: item.rtuId,
                })
                tableData.push({
                  xval: val,
                  linkRelativeVal: linkRelativeVals[i],
                  itemIdName: item.itemIdName,
                  rtuName: item.rtuName,
                  itemId: item.itemId,
                  rtuId: item.rtuId,
                })
              } else {
                tableData.push({
                  xval: val,
                  yval: yvals[i],
                  itemIdName: item.itemIdName,
                  rtuName: item.rtuName,
                  itemId: item.itemId,
                  rtuId: item.rtuId,
                })
              }
            })
          }
          if (param.compareType == '3') {
            chartData.push({...item, yvals: yearOnYearVals})
            chartData.push({...item, yvals: linkRelativeVals})
            columns.push({
              label: item.itemIdName,
              children: [
                {
                  label: item.rtuName,
                  prop: 'yearOnYearVal',
                  search: false,
                  display: false, // 弹出表单是否显示
                  type: "input",
                  addDisplay: false,
                  editDisplay: false,
                  viewDisplay: false,
                },
              ]
            })
            columns.push({
              label: item.itemIdName,
              children: [
                {
                  label: item.rtuName,
                  prop: 'linkRelativeVal',
                  search: false,
                  display: false, // 弹出表单是否显示
                  type: "input",
                  addDisplay: false,
                  editDisplay: false,
                  viewDisplay: false,
                },
              ]
            })
          } else {
            columns.push({
              label: item.itemIdName,
              children: [
                {
                  label: item.rtuName,
                  type: "input",
                  addDisplay: false,
                  editDisplay: false,
                  viewDisplay: false,
                  prop: 'yval',
                  search: false,
                  display: false, // 弹出表单是否显示
                },
              ]
            })
          }
        })
        this.option.column = columns;
        // 如果需要，可以刷新 CRUD 组件（可选）
        // this.$refs.crud.refreshTable();
        this.data = data;
        data.compareType = param.compareType;
        this.tableData = tableData;
        this.loading = false;
        this.$nextTick(() => {
          if (this.$refs.LightChart) {
            this.$refs.LightChart.updateChart(chartData);
          }
        })
      });
    },
    getPageList() {
      if (!this.reportId) {
        console.log('无reportId，不请求');
        this.loading = false;
        return;
      }

      if (this.loading) return;

      this.loading = true;

      const param = {
        compareType: 0, // 默认值
        dataType: 1, // 默认值
        reportId: this.reportId,
        ...this.query,
      };

      getReportDataPage(param)
        .then(res => {
          this.resData = res.data?.data || [];
          this.handleResponseData(this.resData, param);
        })
        .catch(error => {
          console.error('获取报告数据失败:', error);
          this.loading = false;
        });
    },
    
    handleResponseData(data, param) {
      this.option.column = [];
      const tableData = [];
      const chartData = [];
      const columns = [
        {
          label: this.Lang.table.time,
          prop: 'xval',
          search: false,
          display: false, // 弹出表单是否显示
          minWidth: '150px',
        },
      ];

      data.forEach((item, colIndex) => {
        this.processItem(item, colIndex, param.compareType, tableData, chartData, columns);
      });
      this.showAvueCard = false;
      if (data.length) {
        columns.forEach(item => {
          this.option.column.push(item)
        })
        this.tableData = tableData;
      } else {
        this.option.column = [];
        this.tableData = []
      }
      this.showAvueCard = true;
      this.loading = false;

      this.$nextTick(() => {
        if (this.$refs.LightChart) {
          this.$refs.LightChart.updateChart(chartData);
        }
      });
    },

    processItem(oItem, colIndex, compareType, tableData, chartData, columns) {
      const item = oItem || {};
      const xvals = item.xvals || [];
      const yvals = item.yvals || [];
      const yearOnYearVals = item.yearOnYearVal || [];
      const linkRelativeVals = item.linkRelativeVal || [];

      if (colIndex === 0) {
        // 行只需要遍历一次，因为时间都一样
        xvals.forEach((val, i) => {
          if (compareType === '3') {
            const nVal = val || '';
            if (yearOnYearVals.length) {
              tableData.push(
                this.createTableRow(nVal, i, item, 'yearOnYearVal')
              );
            }
            if (linkRelativeVals.length) {
              tableData.push(
                this.createTableRow(nVal, i, item, 'linkRelativeVal')
              );
            }
          } else {
            if (yvals.length) {
              tableData.push(this.createTableRow(val, i, item, 'yvals'));
            }
          }
        });
      }

      if (compareType === '3') {
        if (yearOnYearVals.length) {
          chartData.push({...item, yvals: yearOnYearVals});
          this.addColumn(columns, `${item.itemIdName}(${item.unit})${this.Lang.option.YoY}`, item, 'yearOnYearVal');
        }
        if (linkRelativeVals.length) {
          chartData.push({...item, yvals: linkRelativeVals});
          this.addColumn(columns, `${item.itemIdName}(${item.unit})${this.Lang.option.YoYAndMoM}`, item, 'linkRelativeVal');
        }
      } else {
        if (yvals.length) {
          chartData.push({...item, yvals: yvals});
          this.addColumn(columns, `${item.itemIdName}(${item.unit})`, item, 'yvals'+colIndex);
        }
      }
    },

    createTableRow(xval, xIndex, item, type) {
      const row = {}
      this.resData.forEach((col, i) => {
        row[type+i] = col[type][xIndex] || '';
      })
      return {
        xval, // 时间值
        itemIdName: item.itemIdName,
        rtuName: item.rtuName,
        itemId: item.itemId,
        rtuId: item.rtuId,
        ...row
      };
    },

    addColumn(columns, label, item, prop) {
      let width = '150px';
      if (label.length >= 20) {
        width = '200px';
      }
      if (label.length > 30) {
        width = '280px';
      }
      columns.push({
        label: label,
        children: [
          {
            minWidth: width,
            label: item.rtuName,
            prop,
            search: false,
            display: false, // 弹出表单是否显示
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
